import Reveal from "@/components/base/Reveal";
import { caseCategories } from "@/mocks/cases";

interface CategoryStripProps {
  activeCategory: string;
  onSelect: (id: string) => void;
}

export default function CategoryStrip({ activeCategory, onSelect }: CategoryStripProps) {
  const handleClick = (id: string) => {
    onSelect(id);
    const target = document.getElementById("featured");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-10 md:px-6 md:py-14">
        <Reveal>
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700">
              <i className="ri-layout-grid-line text-base" />
            </span>
            <div>
              <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
                按现场类型快速定位
              </h2>
              <p className="mt-1 text-xs text-foreground-600 md:text-sm">
                选中一个分类，直接跳到下方的现场列表
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-6 flex flex-wrap gap-3">
            {caseCategories.map((cat) => {
              const active = activeCategory === cat.id;
              return (
                <button
                  key={cat.id}
                  type="button"
                  onClick={() => handleClick(cat.id)}
                  className={`inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border px-4 py-2.5 text-sm transition-colors md:px-5 ${
                    active
                      ? "border-primary-600 bg-primary-600 text-background-50"
                      : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
                  }`}
                >
                  <i className={`${cat.icon} text-base`} />
                  {cat.name}
                </button>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}